// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import FullScreen from './FullScreen';
import ThemeToggle from './ThemeToggle';
import EmpresaEmissoraSelect from './EmpresaEmissoraSelect';
import MobileSection from './MobileSection';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {/* Empresa emissora ativa (padrão Workspace do Mantis) — à esquerda, com a busca ao lado */}
      {!downLG && (
        <Stack direction="row" sx={{ gap: 2, ml: 1, alignItems: 'center' }}>
          <EmpresaEmissoraSelect />
          <Divider orientation="vertical" flexItem sx={{ height: 22, alignSelf: 'center' }} />
          <Search />
        </Stack>
      )}
      {downLG && <EmpresaEmissoraSelect />}
      <Box sx={{ width: '100%', ml: 1 }} />

      <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75 }}>
        <ThemeToggle />
        <Notification />
        {!downLG && <FullScreen />}
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Stack>
    </>
  );
}
